import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TitleStrategy, provideRouter } from '@angular/router';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { routes } from './routes';
import { tokenInterceptor } from './Modules/Shared/Interceptors/token.interceptor';
import { loadingInterceptor } from './Modules/Shared/Interceptors/loading.interceptor';
import { errorInterceptor } from './Modules/Shared/Interceptors/error.interceptor';
import { httpLoaderFactory } from './Modules/Shared/Factories/translate-loader.factory';
import { TranslationService } from './Modules/Shared/Services/translation.service';
import { TranslateTitleStrategy } from './Modules/Shared/Strategies/translate-title.strategy';
import { MATERIAL_ICON_FONT_SET } from './Consts/theme.const';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const lang = inject(TranslationService).resolveColdLoadLanguage();

      return firstValueFrom(inject(TranslateService).use(lang));
    }),

    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: TranslateTitleStrategy },
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor, loadingInterceptor, errorInterceptor]),
    ),
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: MATERIAL_ICON_FONT_SET } },

    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
